/**
 * Function: awData
 * @desc grabs object data in __data
 * @param obj amwell object
 */
export function awData(obj: any) {
  // eslint-disable-next-line no-underscore-dangle
  return (obj && obj.__data) || obj;
}

/**
 * Function: prepend
 * @desc prepends 0 for positive integers
 * @param num
 */
export function prepend(num: number) {
  return `0${num}`.slice(-2);
}
